module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_014.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_014.png
// module id = 959
// module chunks = 0